export interface EnvironmentVariables {
    BASE_URL: string,
    REDIRECT_URL: string,
    SILENT_REDIRECT_URL: string,
    ALLOWED_ASSISTANT_ORIGIN: string,
    ALLOWED_SITE_ORIGIN: string,
    AUTH_URL: string,
    IOBWS_URL: string
}

export type IHostEnvironments = 'localhost:3000' | 'developer.arionbanki.is' | 'developer-dev.arionbanki.is' | 'developer-test.arionbanki.is' | 'isit-webportal-ui-*.arionbanki.is'
export function resolveEnvironment(testValue?: { host: IHostEnvironments }, nock = false): EnvironmentVariables { // NOSONAR: cognitive complexity
    const { host } = testValue ?? globalThis.location;
    let BASE_URL;
    let REDIRECT_URL;
    let SILENT_REDIRECT_URL;
    let ALLOWED_ASSISTANT_ORIGIN;
    let ALLOWED_SITE_ORIGIN;
    let AUTH_URL;
    let IOBWS_URL;
    const regexDev = new RegExp(/dev\./, 'i');
    const regexTest = new RegExp(/test\./, 'i');
    const regexIsIt = new RegExp(/isit-/, 'i');
    const regexLocal = new RegExp(/localhost/, 'i');


    const environment = process.env.REACT_APP_DEVELOPMENT_MODE ?? 'local'

    // Are we developing locally?
    if (regexLocal.exec(host) === null) {
        // Else: No, we're deployed somewhere
        // Case for isit- branches
        if (regexIsIt.exec(host)) {
            BASE_URL = 'https://' + host.replace('-ui-', '-api-') + '/api';
            REDIRECT_URL = 'https://' + host + '/user';
            SILENT_REDIRECT_URL = 'https://' + host + '/assisted';
            ALLOWED_ASSISTANT_ORIGIN = 'https://' + host.replace('-ui-', '-ui-assisted-');
            ALLOWED_SITE_ORIGIN = 'https://' + host;
            AUTH_URL = 'https://curity-dev.arionbanki.is'
            IOBWS_URL = 'https://apigwsandbox-dev.arionbanki.is/psd2'

            // Case for prod and dev master branches
        } else {
            BASE_URL = 'https://' + host.replace('developer', 'developerportalapi') + '/api';
            REDIRECT_URL = 'https://' + host + '/user';
            SILENT_REDIRECT_URL = 'https://' + host + '/assisted';
            ALLOWED_ASSISTANT_ORIGIN = 'https://' + host.replace('-ui-', '-ui-assisted-');
            ALLOWED_SITE_ORIGIN = 'https://' + host;
            if (regexDev.exec(host) !== null) {
                // Dev IOBWS and Curity
                IOBWS_URL = 'https://apigwsandbox-dev.arionbanki.is/psd2'
                AUTH_URL = 'https://curity-dev.arionbanki.is'
            }
            else if (regexTest.exec(host) === null) {
                // Prod IOBWS and Curity
                AUTH_URL = 'https://curity.arionbanki.is'
                IOBWS_URL = 'https://apigwsandbox.arionbanki.is/psd2'
            }
            else {
                // Test IOBWS and Curity
                IOBWS_URL = 'https://apigwsandbox-test.arionbanki.is/psd2'
                AUTH_URL = 'https://curity-test.arionbanki.is'
            }
        }
    } else if (environment.localeCompare('local') === 0) {
        // Case for npm run dev — use REACT_APP_BASE_URL when set (e.g. local API), else fall back to deployed dev API
        BASE_URL = nock ? 'https://localhost:44334/api' : (process.env.REACT_APP_BASE_URL ?? 'https://isit-openbanking-webportal-api-master.dev.service.arionbanki.is/api');
        REDIRECT_URL = 'http://localhost:3000/user';
        SILENT_REDIRECT_URL = 'http://localhost:8080/localAssisted.html';
        ALLOWED_ASSISTANT_ORIGIN = 'http://localhost:8080';
        ALLOWED_SITE_ORIGIN = 'http://localhost:3000';
        AUTH_URL = 'https://curity-dev.arionbanki.is'
        IOBWS_URL = 'https://apigwsandbox-dev.arionbanki.is/psd2'
    } else {
        // Case for local docker
        BASE_URL = 'https://isit-openbanking-webportal-api-master.dev.service.arionbanki.is/api';
        REDIRECT_URL = 'http://localhost:3000/user';
        SILENT_REDIRECT_URL = 'http://localhost:3000/assisted';
        ALLOWED_ASSISTANT_ORIGIN = 'http://localhost:8080';
        ALLOWED_SITE_ORIGIN = 'http://localhost:3000';
        AUTH_URL = 'https://curity-dev.arionbanki.is';
        IOBWS_URL = 'https://apigwsandbox-dev.arionbanki.is/psd2';
    }


    //console.info('parsed elements are: ', { BASE_URL, REDIRECT_URL, SILENT_REDIRECT_URL, ALLOWED_ASSISTANT_ORIGIN, ALLOWED_SITE_ORIGIN, AUTH_URL })
    return { BASE_URL, REDIRECT_URL, SILENT_REDIRECT_URL, ALLOWED_ASSISTANT_ORIGIN, ALLOWED_SITE_ORIGIN, AUTH_URL, IOBWS_URL }
}